import { useLocation } from "preact-iso";
import { idx, unitColor } from "../store";
import { settings } from "../lib/state";
import { t } from "../i18n";

export function Nav() {
  const { path } = useLocation();
  const on = (p: string) => (p === "/" ? path === "/" : path.startsWith(p)) ? "on" : "";
  return (
    <nav class="topnav">
      <a href="/" class={on("/")}>{t("catalogue")}</a>
      <a href="/danas" class={on("/danas")}>Danas</a>
      <a href="/u" class={on("/u")}>{t("units")}</a>
      <a href="/rooms" class={on("/rooms")}>{t("rooms")}</a>
      <a href="/about" class={on("/about")}>{t("about")}</a>
      <span class="lang">
        <button onClick={() => (settings.value = { ...settings.value, lang: settings.value.lang === "bs" ? "en" : "bs" })}>
          {settings.value.lang === "bs" ? "EN" : "BS"}
        </button>
      </span>
    </nav>
  );
}

export function Masthead({ compact }: { compact?: boolean }) {
  const core = idx.value!.core;
  const top = [...new Set(core.courses.map((c) => c.fac))].map((f) => [f, core.courses.filter((c) => c.fac === f).length] as const).sort((a, b) => b[1] - a[1]).slice(0, 3);
  return (
    <header class="masthead" style={compact ? "padding-bottom:.9rem" : ""}>
      <div class="mast-left">
        <div class="kicker">{t("kicker")}</div>
        <h1 style={compact ? "font-size:clamp(34px,4vw,52px)" : ""}><a href="/" style="text-decoration:none">Slu<em>šam</em></a></h1>
        {!compact && <p class="dek">{t("dek")}</p>}
        <Nav />
      </div>
      {!compact && (
        <div class="mast-right">
          {top.map(([f, n]) => <div class="stat" key={f}><b style={`color:${unitColor(f)}`}>{n}</b><span>{f}</span></div>)}
          <div class="stat"><b>{core.courses.length}</b><span>{t("courses")}</span></div>
          <div class="stat"><b>{core.units.length}</b><span>{t("units")}</span></div>
        </div>
      )}
    </header>
  );
}
